<template>
  <div class="w-full">
    <div class="w-11/12 mx-auto py-2 flex flex-wrap items-center justify-center">
      <template v-for="(media, index) in filteredMedias">
        <img
          v-if="media.type == 'image'"
          :src="'apidev/uploads/surveys/'+media.filename"
          class="h-40 w-40 m-1 object-cover cursor-pointer shadow-2xl"
          :key="index"
          @click="displayMedia(media)"
        />
        <video
          v-if="media.type == 'video'"
          :key="index"
          class="h-auto w-40 m-1 cursor-pointer shadow-2xl"
          @click="displayMedia(media)"
          oncontextmenu="return false;"
        >
          <source :src="'apidev/uploads/surveys/'+media.filename" />
        </video>
      </template>
    </div>
    <div class="w-11/12 mx-auto">
      <paginate
        :page-count="numberPages"
        :click-handler="pageHandler"
        :prev-text="'Anterior'"
        :next-text="'Siguiente'"
        :container-class="'flex items-center justify-center'"
        :prev-class="'border-2 border-gray-500 text-blue-600 rounded'"
        :prev-link-class="'p-2 flex'"
        :next-class="'ml-1 border-2 border-gray-500 text-blue-600 rounded'"
        :next-link-class="'p-2 flex'"
        :page-class="'ml-1 border-2 border-gray-500 text-blue-600 rounded'"
        :page-link-class="'px-4 py-2 flex'"
        :disabled-class="'page-disabled bg-gray text-gray-700'"
        :active-class="'border-blue-500 bg-gray-300'"
      ></paginate>
    </div>
    <div
      v-if="showMedia"
      class="fixed py-24 px-24 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="absolute top-0 right-0 h-12 w-12 flex items-center justify-center">
        <button
          aria-label="close"
          class="text-2xl text-gray-300 font-bold"
          @click.prevent="closeImage"
        >×</button>
      </div>
      <img
        v-if="selectedMedia.type == 'image'"
        :src="'apidev/uploads/surveys/' + selectedMedia.filename"
        class="h-full w-full p-1 object-contain"
      />
      <video v-if="selectedMedia.type == 'video'" class="max-h-full max-w-full" controls>
        <source :src="'apidev/uploads/surveys/'+selectedMedia.filename" />
      </video>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  name: "multimedia-gallery",
  data() {
    return {
      numberPages: 0,
      maxItemsPerPage: 10,
      currentIndex: 0,
      currentPage: 1,
      showMedia: false,
      selectedMedia: {}
    };
  },
  props: {
    medias: {
      required: true
    }
  },
  components: {
    Paginate
  },
  mounted() {
    this.numberPages = Math.ceil(this.medias.length / this.maxItemsPerPage);
  },
  methods: {
    pageHandler(page) {
      if (page > this.currentPage) {
        let diff = page - this.currentPage;
        this.currentIndex += diff * this.maxItemsPerPage;
        this.currentPage = page;
      }
      if (page < this.currentPage) {
        let diff = this.currentPage - page;
        this.currentIndex -= diff * this.maxItemsPerPage;
        this.currentPage = page;
      }
    },
    displayMedia(media) {
      this.selectedMedia = media;
      this.showMedia = true;
    },
    closeImage() {
      this.showMedia = false;
    }
  },
  computed: {
    filteredMedias() {
      return this.medias.slice(
        this.currentIndex,
        this.currentIndex + this.maxItemsPerPage
      );
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>